import { render, staticRenderFns } from "./ManageClientsEmployee.vue?vue&type=template&id=223c648a&scoped=true&"
import script from "./ManageClientsEmployee.vue?vue&type=script&lang=js&"
export * from "./ManageClientsEmployee.vue?vue&type=script&lang=js&"
import style0 from "./ManageClientsEmployee.vue?vue&type=style&index=0&id=223c648a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c648a",
  null
  
)

export default component.exports